import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Company } from '../models/company';
import { ConnectionService } from '../../../services/connection/connection.service';
import { CompanyWorkingHours } from '../models/company-working-hours';


@Injectable()
export class CompanyInfoOdooService {

  constructor(private connectionService: ConnectionService) { }

  getCompanyInfo(): Observable<Company> {
    return this.connectionService.sendJsonPostRequest('/store/company/company-info', {})
      .pipe(map(
        (result) => {
          return Company.createFromAny(result);
        }),
        catchError(error => {
          return of(null);
        }),
      );
  }

  getSchedule(): Observable<CompanyWorkingHours[]> {
    return this.connectionService.sendJsonPostRequest('/store/company/company-schedule', {})
      .pipe(map(
        (result) => {
          return result.map(schedule => CompanyWorkingHours.createFromAny(schedule));
        }));
  }

  getTodayWorkingHours(): Observable<CompanyWorkingHours> {
    return this.connectionService.sendJsonPostRequest('/store/company/company-today-working-hours', {})
      .pipe(map(
        (result) => {
          return CompanyWorkingHours.createFromAny(result);
        }));
  }
}
